const coupon = {
  getlist: 'coupon/getlist',
  add: 'coupon/add',
  update: 'coupon/update',
  remove: 'coupon/remove',
  get: 'coupon/get',
  getall: 'coupon/getall',
}
export default coupon
